/* unplugin-vue-components disabled */import { render } from "./Djprogram.vue?vue&type=template&id=1d34d672&ts=true"
import script from "./Djprogram.vue?vue&type=script&lang=ts"
export * from "./Djprogram.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Workspaces\\VScode\\vue3+TS\\vue案例\\cloudMusicProject-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/home/cpns/Djprogram.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1d34d672"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1d34d672', __exports__)) {
    console.log('reload')
    api.reload('1d34d672', __exports__)
  }
  
  module.hot.accept("./Djprogram.vue?vue&type=template&id=1d34d672&ts=true", () => {
    console.log('re-render')
    api.rerender('1d34d672', render)
  })

}


export default __exports__